import { Button, Drawer, Form, Input, Table, Tabs } from "antd"
import { useDispatch } from "react-redux"
import { updateUserByIDRequest } from "../../../Stores/UserSlice"

const DrawerDetailUser = ({ isOpen, onClose, data }) => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()

    const onUpdateInfo = () => {
        const dataPayload = form.getFieldsValue(true)
        // Make request
        dispatch(updateUserByIDRequest({
            id: data.id,
            payload: dataPayload
        })).then(res => {
            onClose()
        })
    }

    const tabs = [
        {
            label: `Information`,
            key: 0,
            children: <InfoTab dataInfo={data} onSubmit={onUpdateInfo} form={form} />,
        },
        {
            label: `Keys`,
            key: 1,
            children: <KeysTab data={data["keys"]} />,
        },
        {
            label: `Payments`,
            key: 2,
            children: <PaymentsTab data={data["payments"]} />
        }
    ]
    return (
        <Drawer
            title="User Detail"
            onClose={onClose}
            open={isOpen}
            styles={{ body: { padding: "40px 20px 40px 0" } }}
            width={680}
        >
            <Form
                layout="vertical"
                form={form}
            >
                <Tabs
                    tabPosition="left"
                    centered
                    style={{ height: "100%" }}
                    items={tabs}
                />
            </Form>
        </Drawer>
    )
}

const InfoTab = ({ dataInfo, onSubmit, form }) => {
    const modelField = ['email', 'is_active', 'is_superuser', 'full_name', 'phone_number', 'is_verify', 'password']
    return (
        <>
            {modelField.map((field) => {
                return Object.keys(dataInfo).map((key, index) => {
                    if (field == key) {
                        form.setFieldValue(field, dataInfo[key])
                        return <Form.Item
                            name={key}
                            key={index}
                            label={key.toUpperCase()}
                        >
                            <Input defaultValue={dataInfo[key]} />
                        </Form.Item>
                    }
                })
            })}
            <Form.Item
                name={"password"}
                key={"password"}
                label={"NEW PASSWORD"}
            >
                <Input />
            </Form.Item>

            <Button type="primary" style={{ width: "100%" }} onClick={onSubmit}>Update</Button>
        </>
    )
}

const KeysTab = ({ data }) => {
    const modelField = ['id', 'cycle_id', 'status']
    const columnTable = modelField.map((field) => ({
        title: field.toUpperCase(),
        dataIndex: field,
        key: field,
    }))

    return <Table
        rowKey={'id'}
        columns={columnTable}
        dataSource={data}
        scroll={{
            x: 'max-content',
        }}
    />
}

const PaymentsTab = ({ data }) => {
    const modelField = ['payment_status', 'payment_type', 'payment_id', 'topup_id', 'payment_amount', 'payment_gateway', 'payment_number', 'voucher_id', 'payment_currency', 'payment_method', 'created_at', 'id']
    const columnTable = modelField.map((field) => ({
        title: field.toUpperCase(),
        dataIndex: field,
        key: field,
    }))

    return <Table
        rowKey={'id'}
        columns={columnTable}
        dataSource={data}
        scroll={{
            x: 'max-content',
        }}
    />
}

export default DrawerDetailUser